"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Configuration;

var _immutable = _interopRequireDefault(require("immutable"));

var defaultState = _immutable.default.Map({
  withShutterstock: false
});

function Configuration() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  var type = action.type;

  switch (type) {
    default:
      return state;
  }
}

module.exports = exports.default;